import React from "react";

export interface IContentContext {
  /** Some text for the article */
  text: string;
  /** Indicates should it be treated as inner article or as raw text (false) */
  isArticle?: boolean;
}

export const DEFAULT_CONTENT_CONTEXT: IContentContext = {
  isArticle: false,
  text: "",
};

/** Context for article (WYSIWYG) text / custom properties */
const ContentContext = React.createContext<IContentContext>(
  DEFAULT_CONTENT_CONTEXT,
);

export default ContentContext;
